export {
  useConfettiFriesAnimation,
  ConfettiFriesAnimationProvider,
} from './use-confetti-fries-animation';
export { ConfettiFriesAnimation as default } from './confetti-fries-animation';
